module.exports = __webpack_public_path__ + "static/media/palm_tree.667047af.svg";